// The page the user lands on after opening the app and without a session

export const FirstRunPage = 'TutorialPage';//'TutorialPage';MenuPage

// The main page the user will see as they use the app over a long period of time.
// Change this if not using tabs
export const MainPage = 'MenuPage';

// The initial root pages for our tabs (remove if not using tabs)
export const Tab1Root = 'DiscoverPage';
export const Tab2Root = 'HomePage';
// export const Tab3Root = 'MoveshopPage';
export const Tab3Root = 'PostNotesPage';
export const Tab4Root = 'ArticlePage';
export const Tab5Root = 'MyPage';



// WEBPACK FOOTER //
// ./src/pages/pages.ts